import { render, staticRenderFns } from "./ResultView.vue?vue&type=template&id=4578cbfa&scoped=true"
import script from "./ResultView.vue?vue&type=script&lang=js"
export * from "./ResultView.vue?vue&type=script&lang=js"
import style0 from "./ResultView.vue?vue&type=style&index=0&id=4578cbfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4578cbfa",
  null
  
)

export default component.exports